import React from "react";
import "./styling.css";

export default function ViewSelectionButton({
  enabled,
  Title,
  selectionHandler,
  backgroundSource,
  imageSource,
}) {
  return (
    <div className="container">
      <button
        disabled={!enabled}
        className="selectionButton"
        onClick={() => selectionHandler(backgroundSource)}
      >
        <img alt="" className="selectionImage" src={imageSource}></img>
        <h1>{Title}</h1>
      </button>
    </div>
  );
}
